<template>
  <!--  评论-->
  <div>

  </div>
</template>

<script>
export default {
  name: "rate",
  created() {
    document.title = '订单评价 - JapanHui';
  },
}
</script>

<style scoped>

</style>